<template>
    <b-collapse :visible="visible" id="content">
        <card>
            <b-row>
                <b-col>
                    <card header-classes="bg-transparent">
                        <div slot="header" class="row align-items-center">
                            <div class="col">
                                <h5 class="h3 mb-0">Script Details</h5>
                            </div>
                        </div>
                        <div class="overflow-auto">
                            <b-pagination v-model="currentPage"
                                          :total-rows="rows"
                                          :per-page="perPage"
                                          aria-controls="openPAsTable">
                            </b-pagination>
                            <b-table id="openPAsTable"
                                     :items="tableData"
                                     :fields="tableColumns"
                                     :per-page="perPage"
                                     :current-page="currentPage"
                                     small
                                     striped>
                                <template #cell(scriptSubstatus)="data">
                                    <div v-b-tooltip.hover :title="GetStatusExplanation(data.value)" class="text-center" style="cursor:pointer">
                                        <b>
                                            {{data.value}}
                                        </b>
                                    </div>
                                </template>
                            </b-table>
                            
                        </div>
                    </card>
                </b-col>
            </b-row>
        </card>
    </b-collapse>
</template>

<script>
    export default {
        name: 'ScriptDetailsCharts',
        components: {
        },
        props: {
            apiEndpoint: String
        },
        data() {
            return {
                tableColumns: [
                    { key: 'patientId', label: 'Patient ID', sortable: true, class:'tableToolTip' },
                    { key: 'newRefill', label: 'New/Refill', sortable: true },
                    { key: 'hcp', label: 'HCP', sortable: true },
                    { key: 'drugname', label: 'Drug Name', sortable: true },
                    { key: 'quantity', label: 'Quantity', sortable: true },
                    { key: 'dispensed', label: 'Dispensed', sortable: true },
                    { key: 'writtendate', label: 'Written Date', sortable: true },
                    { key: 'filldate', label: 'Fill Date', sortable: true },
                    { key: 'copay', sortable: true },
                    { key: 'paidbyplan1', label: 'Paid By Plan 1', sortable: true },
                    { key: 'paidbyplan2', label: 'Paid By Plan 2', sortable: true },
                    { key: 'bin', label: 'BIN', sortable: true },
                    { key: 'pcn', label: 'PCN', sortable: true },
                    { key: 'scriptStatus', label: 'Status Code', sortable: true },
                    { key: 'scriptSubstatus', label: 'Sub-Status Code', sortable: true },
                    { key: 'shipdate', label: 'Ship Date', sortable: true }
                ],
                perPage: 50,
                currentPage: 1,
                visible: false,
                tableData: [],

            };
        },
        methods: {
            fetchData() {
                this.axios.get(this.apiEndpoint)
                    .then(response => {
                        this.tableData = response.data.map(d => {
                            return {
                                patientId: d.patientId,
                                drugname: d.drugName,
                                filldate: d.fillDate,
                                writtendate: d.writtenDate,
                                shipdate: d.shipDate,
                                copay: '$' + (d.copay / 100).toFixed(2),
                                paidbyplan1: '$' + (d.paidByPlan1 / 100).toFixed(2),
                                paidbyplan2: '$' + (d.paidByPlan2 / 100).toFixed(2),
                                bin: d.bin,
                                pcn: d.pcn,
                                scriptStatus: d.scriptStatus,
                                scriptSubstatus: d.scriptSubstatus,
                                hcp: d.hcp,
                                quantity: d.quantity.toFixed(2),
                                dispensed: d.dispensed.toFixed(2),
                                newRefill: d.newRefill
                            };
                        })
                    })
                    .catch(error => {
                        
                    });

            },
            GetStatusExplanation(status) {
                if (status == 'SHIPPED')
                    return 'The Rx was shipped within the last 7 days'
                if (status == 'READY')
                    return 'The Rx is ready to be loaded and shipped'
                if (status == 'PATIENT_RESP')
                    return 'The Rx is on hold because patient has ceased responding'
                if (status == 'PRESCRIBER_HOLD')
                    return 'The Rx is on hold due to prescriber'
                if (status == 'INSURANCE_HOLD')
                    return 'The Rx is on hold due to insurance issues'
                if (status == 'HOLD_OTHER')
                    return 'The Rx is on hold due other reasons'
                if (status == 'COMPLETED')
                    return 'The Patient has received their Rx'
                if (status == 'TRANSFER_PHARM')
                    return 'The Patient transferred the Rx to another Pharmacy'
                if (status == 'OTHER')
                    return 'The Order has been cancelled due to other reasons'
                if (status == 'PRIORAUTH')
                    return 'The Rx has an active PA in progress'
                if (status == 'OON')
                    return 'The Rx is on hold because the Patient is out of network'
                if (status == 'NEW')
                    return 'The Rx is awaiting processing'
                if (status == 'INVENTORY_HOLD')
                    return 'The Rx is currently out of stock';
                else {
                    return 'Status Unknown'
                }
            },

        },
        watch: {
            apiEndpoint: function () {
                this.currentPage = 1
                this.fetchData();
                this.visible = true;

            },
        },
        computed: {
            rows() {
                return this.tableData.length
            }
        },
        mounted() {
        }
    }
</script>

<style scoped>
    .tableToolTip:hover span {
        display: block;
        position: absolute;
        background-color: #FFF;
        border: 1px solid #CCC;
        margin: 2px 10px;
    }
</style>